import React, { useState } from 'react';
import { IoCopyOutline } from 'react-icons/io5';
import { FaCheck } from 'react-icons/fa';
import { colors } from '../../constants';

export const Copy = ({ children, value, style, checkStyle, innerStyle, onlyCheck, blue }) => {
  const [success, setSuccess] = useState();

  const handleCopy = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setSuccess(true);
    navigator.clipboard.writeText(value);
    setTimeout(() => setSuccess(false), 2000);
  };

  const blueStyle = blue
    ? {
        border: `1px solid ${colors.brightBlue}`,
        background: colors.lightBlue,
        color: colors.brightBlue,
        fontWeight: 'bold',
        padding: '4px 12px',
        borderRadius: 16,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }
    : {};

  const innerBlueStyle = blue
    ? {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }
    : {};

  return (
    <div
      style={{
        cursor: onlyCheck ? null : 'pointer',
        display: 'flex',
        alignItems: 'flex-start',
        gap: 4,
        ...blueStyle,
        ...(style || {}),
      }}
      onClick={onlyCheck ? undefined : handleCopy}
    >
      <div style={{ ...innerBlueStyle, ...innerStyle }}>{children}</div>
      <div
        onClick={onlyCheck ? handleCopy : undefined}
        style={{ display: 'flex', width: 16, cursor: 'pointer', alignItems: 'center', ...(checkStyle || {}) }}
      >
        {success ? <FaCheck /> : <IoCopyOutline />}
      </div>
    </div>
  );
};
